import type {
  CashSummary,
  CreateMovementPayload,
  UpsertClosurePayload,
} from '../types/cash';
import { http } from './http';

function buildSummaryUrl(date: string, posId?: string) {
  const params = new URLSearchParams({ date });
  if (posId) params.append('posId', posId);
  return `/cash/summary?${params.toString()}`;
}

export const cashApi = {
  getSummary: (token: string | null, date: string, posId?: string) =>
    http<CashSummary>(
      buildSummaryUrl(date, posId),
      { method: 'GET' },
      token
    ),

  createMovement: (token: string | null, payload: CreateMovementPayload) =>
    http<{ success: boolean }>(
      `/cash-drawer/movements`,
      {
        method: 'POST',
        body: JSON.stringify(payload),
      },
      token
    ),

  upsertClosure: (token: string | null, payload: UpsertClosurePayload) =>
    http<{ success: boolean }>(
      `/cash-closures`,
      {
        method: 'POST',
        body: JSON.stringify(payload),
      },
      token
    ),
};